import { ENDPOINTS } from "@/constants/endpoints"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type { Notification } from "@/types/notificationTypes"

export const useNotificationsData = () => {
  return useGenericQuery<Array<Notification>>({
    keys: QUERY_KEYS.notifications.index(),
    apiEndpoint: ENDPOINTS.notifications.index(),
  })
}
